import axios from "./backendAxios";
import errors from "../errors";

const noop = () => {};

const axiosStripe = {
  addPaymentMethod: async (data, onSuccess = noop, onFail = noop) => {
    try {
      const res = await axios.post("stripe/customer/payment-method/add", data);

      if (res.data.success) {
        console.log("Successfully removed payment method!");
        onSuccess(res.data);
      } else {
        throw res.data.message;
      }
    } catch (error) {
      console.error("Stripe Remove Payment Method Error: ", error);
      errors.report(error);
      onFail(error);
    }
  },
};

export default axiosStripe;
